import { TFunction } from "i18next";
import * as yup from "yup";

export interface OtherLegalEntityLocationValidationSchemeProps {
  t: TFunction;
}

export const OtherLegalEntityLocationValidationScheme = ({
    t,
  }: OtherLegalEntityLocationValidationSchemeProps) => {
    const requiredMsg = t("validations.required");
    const documentTooBig = t("errorCode.Document.TooBig");
    const documentWrongFormat = t("errorCode.Document.WrongFormat");
    const now = new Date();
    const todayLastSecond = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    const dateInFutureMsg = t("request.executionResolutionDocumentMaxDate");
    const dateFromLessThanDateToMsg = t("validations.dateFromLessThanDateTo");
  
    return yup.object().shape({
      name: yup.string().required(requiredMsg),
      programExecutionRequestDocument: yup.mixed().required(requiredMsg).test('programExecutionRequestDocument', documentTooBig, val => {        
        if(val && val.id !== -1){
          return true;
        }
        if(val && val.file.size <= 10485760){
          return true;
        }
        return false;
      }).test('programExecutionRequestDocument', documentWrongFormat, val => {
        if(val){
          var split = val.fileName.split('.');
          var ext = split[split.length - 1];
        
          if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
           return true;
          }
        }
  
        return false;
      }),      
      ministryConsentDocument: yup.mixed().required(requiredMsg).test('ministryConsentDocument', documentTooBig, val => {        
        if(val && val.id !== -1){
          return true;
        }
        if(val && val.file.size <= 10485760){
          return true;
        }
        return false;
      }).test('ministryConsentDocument', documentWrongFormat, val => {
        if(val){
          var split = val.fileName.split('.');
          var ext = split[split.length - 1];
        
          if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
           return true;
          }
        }
  
        return false;
      }),
      personnelConditionsDocument: yup.mixed().required(requiredMsg).typeError(requiredMsg).test('personnelConditionsDocument', documentTooBig, val => {
        if(val && val.id !== -1){
          return true;
        }
        if(val && val.file.size <= 10485760){
          return true;
        }
        return false;
      }).test('personnelConditionsDocument', documentWrongFormat, val => {
        if(val){
          var split = val.fileName.split('.');
          var ext = split[split.length - 1];
      
          if(ext === "pdf" || ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "gif" || ext === "tiff" || ext === "bmp"){
            return true;
          }
        }
        return false;
      }),
      address: yup.string().required(requiredMsg),      
      town: yup.object().shape({
        id: yup.number().required(requiredMsg).test('id', requiredMsg, val => {          
          if(val){
            if(val === 0){
              return false;
            }
            return true;
          }
          return false;
        }),
        municipalityId: yup.number().required(requiredMsg).test('municipalityId', requiredMsg, val => {          
          if(val){
            if(val === 0){
              return false;
            }            
            return true;
          }
          return false;
        }),
        countyId: yup.number().required(requiredMsg).test('countyId', requiredMsg, val => {          
          if(val){
            if(val === 0){
              return false;
            }
            return true;
          }
          return false;
        })
      }),      
      dateFrom:
        yup.date().required(requiredMsg).max(todayLastSecond, dateInFutureMsg),
      dateTo:
        yup.date().required(requiredMsg)
          .min(yup.ref("dateFrom"), dateFromLessThanDateToMsg),
    });
  };